import React, { useState } from 'react';
import { DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import TaskFormFields from './TaskFormFields';
import { useTaskFormState } from '@/hooks/useTaskFormState';

const TaskForm = ({ task, onSave, onCancel }) => {
  const {
    formData,
    projects,
    assignableEmployees,
    statuses,
    isFetchingRelatedData,
    handleChange,
    handleSelectChange,
    handleDateChange,
  } = useTaskFormState(task);

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // Ensure that empty strings for IDs are converted to null for DB
    const dataToSave = {
      ...formData,
      project_id: formData.project_id || null,
      assignee_id: formData.assignee_id || null,
      status_id: formData.status_id || null,
      due_date: formData.due_date || null,
    };
    await onSave(dataToSave);
    setIsLoading(false);
  };

  return (
    <DialogContent className="sm:max-w-[525px] bg-slate-800 border-slate-700 text-slate-100">
      <DialogHeader>
        <DialogTitle className="text-2xl text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">
          {task ? 'Edit Task' : 'Create New Task'}
        </DialogTitle>
        <DialogDescription className="text-slate-400">
          {task ? 'Update the details of this task.' : 'Fill in the details to create a new task.'}
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={handleSubmit}>
        <TaskFormFields
          formData={formData}
          projects={projects}
          assignableEmployees={assignableEmployees}
          statuses={statuses}
          isFetchingRelatedData={isFetchingRelatedData}
          handleChange={handleChange}
          handleSelectChange={handleSelectChange}
          handleDateChange={handleDateChange}
          task={task}
        />
        <DialogFooter className="pt-4">
          <Button type="button" variant="outline" onClick={onCancel} disabled={isLoading || isFetchingRelatedData} className="text-slate-300 border-slate-600 hover:bg-slate-700 hover:text-slate-100">
            Cancel
          </Button>
          <Button type="submit" disabled={isLoading || isFetchingRelatedData} className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white">
            {isLoading ? (task ? 'Saving...' : 'Creating...') : (task ? 'Save Changes' : 'Create Task')}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  );
};

export default TaskForm;